var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesTabsIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.64,
    fill: "#5091EE",
    d: "M20 27l7-7h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2174EA",
    d: "M29 20l7 7v-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.64,
    fill: "#5091EE",
    d: "M36 29l-7 7h7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2174EA",
    d: "M27 36l-7-7v7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTabsIcon03);
export default __webpack_public_path__ + "static/media/features-tabs-icon-03.40aa43d144d935c2f0c117106e14635d.svg";
export { ForwardRef as ReactComponent };